import type { ComparisonOperator } from '@/alerts/treeTypes'

// The consumption node stores the operator as a choice id. Ids 1 to 3 predate
// >= and <=, so they keep their meaning in saved uiData.
export const COMPARISON_OPERATORS: ReadonlyArray<{
  id: string
  operator: ComparisonOperator
  label: string
}> = [
  { id: '1', operator: '>', label: 'מעל' },
  { id: '2', operator: '<', label: 'מתחת' },
  { id: '3', operator: '=', label: 'שווה ל-' },
  { id: '4', operator: '>=', label: 'מעל או שווה ל-' },
  { id: '5', operator: '<=', label: 'מתחת או שווה ל-' },
]

export const operatorForChoice = (id: string): ComparisonOperator =>
  COMPARISON_OPERATORS.find(o => o.id === id)?.operator ?? '>'

export const choiceForOperator = (operator: string): string =>
  COMPARISON_OPERATORS.find(o => o.operator === operator)?.id ?? '1'
